import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'PackagesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-packages",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 16.5l-5 -3l5 -3l5 3v5.5l-5 3z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M2 13.5v5.5l5 3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 16.545l5 -3.03"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 16.5l-5 -3l5 -3l5 3v5.5l-5 3z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 19l5 3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 16.5l5 -3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 13.5v-5.5l-5 -3l5 -3l5 3v5.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 5.03v5.455"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 8l5 -3"
    }, null), _createTextVNode(" ")]);
  }
};